import React, { useState, useEffect } from "react";
import { Route, Routes, Navigate, useLocation, useNavigate } from "react-router-dom";


import Header from "./component/header";
import Footer from "./component/footer";
import MainRoutes from "./routes";




const App = () => {


  return (
    <>
      <Header  />
      <MainRoutes  />
      <Footer />
    </>
  );
};

export default App;